module.exports = __webpack_public_path__ + "img/wechat4.78c8be62.png";